import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router";
import { setProfile } from "../redux/actions/themeActions";
import AuthService from "./../libs/services/auth";
import { useNavigate } from "react-router-dom";

function UnAuthGuard({component, dispatch}){
    const [status, setStatus] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        checkToken();
    }, []);

    const checkToken = async () => {
        if (localStorage.getItem("token-reinsurance")) {
            try {
                let user = await AuthService.getProfile();
                if (!user) {
                    localStorage.removeItem("token-reinsurance")
                } else {
                    navigate(`/`);
                }
                setStatus(true);
                dispatch(setProfile(user))
            } catch (error) {
                navigate(`/`);
            }
        } else {
            setStatus(true);
        }
    }

    return status ? <React.Fragment>{component}</React.Fragment> : <React.Fragment></React.Fragment>;
}


export default connect(store => ({ theme: store.themeReducer }))(UnAuthGuard)